// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { Glyphicon } from 'react-bootstrap';
import { isMobileResolution } from '../../../infrastructure/utils/common';

export default class CityHappeningsElement extends React.PureComponent {
  deleteCityHappenings = event => {
    event.stopPropagation();
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { actions } = this.props;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    actions.deleteCityHappenings(
      event.currentTarget.getAttribute('data-name'),
      'happenings'
    );
  };

  formatstr = str => {
    const st = str.split('\n');
    return st.length > 1 ? `${st[0]}...` : st[0];
  };

  updateCityHappenings = event => {
    event.stopPropagation();
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { actions } = this.props;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    actions.updateCityHappenings(
      event.currentTarget.getAttribute('data-name'),
      'happenings'
    );
  };

  render() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { value, ind } = this.props;
    const isMobile = isMobileResolution();
    return (
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      <tr key={value.title} data-name={ind} className='listrow moveable'>
        <td style={{ verticalAlign: 'middle' }}>
          <Glyphicon glyph='option-vertical' />
        </td>
        {/* TODO: Fix this the next time the file is edited. */}
        {/* eslint-disable-next-line react/prop-types */}
        <td style={{ maxWidth: '90px' }} title={value.title}>
          {/* TODO: Fix this the next time the file is edited. */}
          {/* eslint-disable-next-line react/prop-types */}
          <span className='big-text-field'>{value.title}</span>
        </td>
        {!isMobile && (
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/prop-types
          <td style={{ maxWidth: '60px' }} title={value.subtitle}>
            {/* TODO: Fix this the next time the file is edited. */}
            {/* eslint-disable-next-line react/prop-types */}
            <span className='big-text-field'>{value.subtitle}</span>
          </td>
        )}
        {!isMobile && (
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/prop-types
          <td style={{ maxWidth: '90px' }} title={value.text}>
            {/* TODO: Fix this the next time the file is edited. */}
            {/* eslint-disable-next-line react/prop-types */}
            <span className='big-text-field'>{this.formatstr(value.text)}</span>
          </td>
        )}
        <td
          style={{
            width: '5%',
            textAlign: 'center',
            verticalAlign: 'middle',
            cursor: 'pointer',
            minWidth: '55px',
          }}
        >
          <i
            className='fas fa-pen'
            data-name={ind}
            onClick={this.updateCityHappenings}
            style={{ marginRight: '10px' }}
          />
          <i
            className='fas fa-times'
            data-name={ind}
            onClick={this.deleteCityHappenings}
          />
        </td>
      </tr>
    );
  }
}
